export default {
    fontSize: '20px',
    fontName: 'Traditional',
    namaAlmarhum: [
        " رُقَيَّة بِنْت مُحَمَّد الكَاف",
       " مَسْتُوْرَة بِنْت عَبْدُ اللّٰه المدحيج",
       " نُوْر بِنْت مُحَمَّد الكَاف",
       " مُحَمَّد بن عَلْوِي الكَاف",
       " فَاطِمَة بِنْت عَقِيْل بلفقيه",
       " زُبَيْدَة بِنْت عَبْدُ اللّٰه المدحيج",
       " عَقِيْل بن عَبْدُ اللّٰه المدحيج",
       "فضل بنت محمد بن شهاب",
       " على بن هَاشِم الكَاف",
       " طَلْحَة بِنْت على الكَاف",
       " شَيْخَة بِنْت حَسَن الكَاف",
       "فاطمة بنت حسن الكاف",
       "نور بنت حسن الكاف",
       "محسن بن حسن الكاف",
       "علوى بن حسن الكاف",
       " سِيْدَة بِنْت حُسَيْن العَطَّاس",
       "مصطفى بن حسن الحبشى ",
       " زَيْنَة بِنْت عَلْوِي الكَاف",
       "عيدروس عبد الرحمن الحبشى",
       "ٌRoquan binti Abdullah Bahsien",
       "على بن عبد الرحمن الحبشى",
       "رُقَيَّة بنت شيخ الحبشى",
       "أحمد ايفيندى بن سالم بن شهاب",
       "مَرْيَم بنت محمد شيخ ابو بكر",
       " حُسَيْن بن عُمَر بن شِهَاب",
       " عَبْدُ اللّٰه بن عيدْرُوْس بن شِهَاب",
   ],
    kataganti: '1'
}